var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profileLoaded)?_c('v-app',{attrs:{"id":"aps"}},[_c('router-view'),(_vm.userProfile)?_c('UserProfile',{ref:"UserProfile"}):_vm._e(),_c('Loading',{ref:"Loading"}),_c('SnackBar',{ref:"SnackBar"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }